import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';

export const WorkbookLineageCountsFragmentGql: DocumentNode = gql`
fragment WorkbookLineageCountsFragment on Workbook {
  upstreamDatabasesConnection {
    totalCount
  }
  upstreamTablesConnection {
    totalCount
  }
  upstreamVirtualConnectionsConnection @flag(enabled: $publishedConnectionsLineageEnabled) {
    totalCount
  }
  upstreamVirtualConnectionTablesConnection @flag(enabled: $publishedConnectionsLineageEnabled) {
    totalCount
  }
  upstreamFlowsConnection {
    totalCount
  }
  upstreamDatasourcesConnection {
    totalCount
  }
  dashboardsConnection {
    totalCount
  }
  sheetsConnection {
    totalCount
  }
  downstreamMetricsConnection {
    totalCount
  }
  downstreamOwnersConnection {
    totalCount
  }
}
`;
